import { ChangeDetectionStrategy, Component, ElementRef, input, viewChild } from '@angular/core';
import { MarkantElementsModule } from '@markant/elements-angular';

@Component({
  selector: 'markant-platform-expansion-panel',
  standalone: true,
  imports: [MarkantElementsModule],
  templateUrl: './expansion-panel.component.html',
  styleUrl: './expansion-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpansionPanelComponent {
  label = viewChild.required('input', { read: ElementRef });

  id = input.required<string>();
  title = input.required<string>();
  iconPosition = input<'left' | 'right'>('right');
  collapsed = input<boolean>(true);

  // accessibility control
  onKeyDown(e: KeyboardEvent): void {
    if (e.code === 'Enter' || e.code === 'Space') {
      e.preventDefault();
      this.label().nativeElement.click();
    }
  }
}
